import BoxLayer from "../../layers/BoxLayer";
import GridFactory from "./GridFactory";
import Firework from "../firework/FireworkController";
import WaterFallAnimation from "../../animations/WaterFallAnimation";
import { EventBus, EnumEventBus } from "../../managers/EventBus";
import WinningIcon from "../WinningIcon";
import { shuffleArray } from "../../helper/shuffleArray";
import { WFireworkInt } from "../../types/Interface";
import { CLEARING_FW_ANIM_DURATION, LOADING_FW_ANIM_DURATION, FIREWORK_INITIAL_Y_OFFSET } from "../../types/Config";

const offsetY = FIREWORK_INITIAL_Y_OFFSET;
const bClearing = CLEARING_FW_ANIM_DURATION;
const bLoading = LOADING_FW_ANIM_DURATION;


export default class Grid {
  static instance;
  private BoxLayer = BoxLayer.getInstance();
  private EventBus = EventBus;
  private hand: number[];
  private betAmount: number;
  private prevGrid: (Firework | WinningIcon)[][] = [[], [], [], []];
  grid: (Firework | WinningIcon)[][] = [[], [], [], []];
  winningFireworks: WFireworkInt[] = [];
  newHandTime: number;
  isOpenHTP: boolean;
  isManuelExplode: boolean = false;
  totalMultiplier: number = 1;
  constructor(initialGame: number[]) {
    if (!Grid.instance) {
      Grid.instance = this;
    }
    this.setHand(initialGame);
    this.generateGrid(0);

    this.EventBus.on(EnumEventBus.getAmount, (amount: string) => this.betAmount = Number(amount))
    this.EventBus.on(EnumEventBus.explAllWFireworks, () => this.explodeAllWFireworks())
    this.EventBus.on(EnumEventBus.setHowToPlayMode, a => this.isOpenHTP = Boolean(a));
    this.EventBus.on(EnumEventBus.setManuelExplode, v => this.isManuelExplode = Boolean(v));

    this.EventBus.emit(EnumEventBus.requestAmount);
  }
  setHand(game: number[]) {
    this.hand = game;
  }
  getHand() {
    return this.hand
  }
  setTotalWon() {
    this.EventBus.emit(EnumEventBus.setTotalWon, this.betAmount * this.totalMultiplier);
  }
  showFWString = (duration: number) => setTimeout(() => this.grid.flat().forEach(fw => fw.setTail(true)), duration);
  runGridAnimation(hand: number[], isAutoPlay: boolean) {
    this.hand = hand;
    this.generateGrid(offsetY);
    const onComp = () => {
      this.showFWString(500)
      if (isAutoPlay || !this.isManuelExplode) {
        setTimeout(() => this.explodeAllWFireworks(), 1000);
        return
      }
      this.addInteractivityWFireworks();
    };
    if (this.prevGrid[0].length > 0) {
      const _onComp = () => {
        this.addInteractivityWFireworks();
        setTimeout(() => this.destoryPrevGrid(), 3000);
      }
      this.startAnimation(this.prevGrid, bClearing, _onComp);
    }
    setTimeout(() => this.startAnimation(this.grid, bLoading, onComp), 300);
  }
  explodeAllWFireworks() {
    let cumulativeTime = 0;
    if (this.winningFireworks.length == 0) {
      this.setTotalWon();
      return this.EventBus.emit(EnumEventBus.gameIsCompleted);
    }
    const randomwinningFireworks = shuffleArray(this.grid.flat());
    randomwinningFireworks.forEach((Fw, wI) => {
      const time = [70, 110, 130][Math.floor(Math.random() * 3)]
      cumulativeTime += time;
      setTimeout(() => {
        Fw.explode();
      }, cumulativeTime);
    });
  }
  startWinFwShrinkAnim() {
    setTimeout(() => {
      if (Date.now() > this.newHandTime + 4000) {
        this.winningFireworks.forEach(wFirework => wFirework.firework.startAnimation())
      }
    }, 5000);
  }
  addInteractivityWFireworks() {
    this.startWinFwShrinkAnim();
    this.winningFireworks.forEach(wFirework => wFirework.firework.setInteractivity(true))
  }
  removeInteractivityWFireworks(winningFirework: Firework) {
    winningFirework.alpha = 0;
    winningFirework.setInteractivity(false);
  }
  destoryPrevGrid() {
    this.prevGrid.forEach(r => r.forEach(fw => fw.remove()))
    this.prevGrid = []
  }
  startAnimation(grid: (Firework | WinningIcon)[][], animDuration: number, onComp: () => void) {
    new WaterFallAnimation({ grid: grid, onComp: () => onComp() }, animDuration)
  }
  generateGrid(yOffset: number) {
    if (this.grid[0].length > 0) {
      this.prevGrid = this.grid;
      this.grid = []
    }

    const newGrid = new GridFactory(this.hand, yOffset, !this.newHandTime);
    newGrid.grid.forEach(c => c.forEach(fw => {
      yOffset == 0 && fw.setTail(true)
      this.BoxLayer.addChild(fw)
    }))
    Object.assign(this, newGrid);
  }
  static getInstance = (): Grid => Grid.instance;
}